import React, { Component } from 'react';
import {
  withRouter,
} from 'react-router-dom';

import {
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Tabs,
  Tab,
  Button,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import FilterList from './FilterList';

import classes from '../../css/getCSS';


class SearchLeftPanel extends Component {
  state = {
    tabValue: 0,
    filters: {},
  };

  handleChange = (event, value) => {
    this.setState({
      tabValue: value,
    });
  };

  selectSingle = (key, value) => {
    this.props.selectSingle(key, value);
  }

  selectMultiple = (key, value) => {
    this.props.selectMultiple(key, value);
  }

  applyFilters = () => {
    this.props.applyFilters(this.state.filters);
  }

  render() {
    const sortList = [
      { value: 'last-login', display_value: 'Last Login' },
      { value: 'newest-first', display_value: 'Newest First' },
      { value: 'oldest-first', display_value: 'Oldest First' },
    ];

    let content = null;
    if (this.state.tabValue === 0) {
      content = (
        <React.Fragment>
          <Typography variant="subheading" style={{ padding: '10px' }}>Age</Typography>
          <FilterList selectSingle={this.selectSingle} facet="age" activeFilters={this.props.activeFilters} />
          <Typography variant="subheading" style={{ padding: '10px' }}>Height</Typography>
          <FilterList selectSingle={this.selectSingle} facet="height" activeFilters={this.props.activeFilters} />
        </React.Fragment>
      );
    }

    if (this.state.tabValue === 1) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.marital_status} facet="marital_status" />;
    }

    if (this.state.tabValue === 2) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.caste} facet="caste" />;
    }

    if (this.state.tabValue === 3) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.profession} facet="profession" />;
    }

    if (this.state.tabValue === 4) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.work_profile} facet="work_profile" />;
    }

    if (this.state.tabValue === 5) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.qualification} facet="qualification" />;
    }

    if (this.state.tabValue === 6) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.study_field} facet="study_field" />;
    }

    if (this.state.tabValue === 7) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.degree} facet="degree" />;
    }

    if (this.state.tabValue === 8) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.from_india} facet="from_india" />;
    }

    if (this.state.tabValue === 9) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.country} facet="country" />;
    }

    if (this.state.tabValue === 10) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.city} facet="city" />;
    }

    if (this.state.tabValue === 11) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.bureau} facet="bureau" />;
    }

    if (this.state.tabValue === 12) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.income} facet="income" />;
    }

    if (this.state.tabValue === 13) {
      content = <FilterList selectSingle={this.selectSingle} list={sortList} facet="sort" />;
    }

    if (this.state.tabValue === 14 && this.props.user.is_premium) {
      content = <FilterList selectMultiple={this.selectMultiple} list={this.props.facets.is_premium} facet="is_premium" />;
    }


    return (
      <Dialog
        fullScreen
        open={this.props.filtersOpen}
        onClose={this.props.closeFilters}
        style={{ paddingBottom: '50px', paddingTop: '47px' }}
        classes={{
          paper: classes.dialogCard,
        }}
      >
        <AppBar position="fixed" elevation={1} color="default">
          <Tabs
            value={this.state.tabValue}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="on"
          >
            <Tab label="Age &amp; Height" />
            <Tab label="Marital Status" />
            <Tab label="Caste" />
            <Tab label="Profession" />
            <Tab label="Work Profile" />
            <Tab label="Qualification" />
            <Tab label="Study Field" />
            <Tab label="Degree" />
            <Tab label="Candidates living in India?" />
            <Tab label="Country" />
            <Tab label="City" />
            <Tab label="Bureau" />
            <Tab label="Income" />
            <Tab label="Sort" />
            {this.props.user.is_premium && (<Tab label="Show Gor Maharaj (premium) profiles" />)}
          </Tabs>
        </AppBar>
        {content}
        <AppBar className={classes.filtersAppBar}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.grow}>Filters</Typography>
            <Button onClick={this.applyFilters} color="inherit">Apply Filters</Button>
            <IconButton color="inherit" onClick={this.props.closeFilters} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </Dialog>
    );
  }
}

export default withRouter(SearchLeftPanel);



// WEBPACK FOOTER //
// ./src/search/components/MobileSearchFilters.js